import { GlobalStyles } from "@mui/material";

export const FullscreenGlobalStyles = () => (
  <GlobalStyles
    styles={{
      ".no-padding": {
        padding: "0 !important",
      },
    }}
  />
);